import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import React, { ReactNode } from 'react'

interface OwnProps {
  title: string
  open: boolean
  loading: boolean
  disabledSubmit?: boolean
  content?: ReactNode
  onCancel: () => void
  onSubmit: () => void
}

const ApprovalsModal: React.FC<OwnProps> = (props: OwnProps) => {
  return (
    <Dialog open={props.open} onClose={props.onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{props.title}</DialogTitle>
      {props.content && <DialogContent>{props.content}</DialogContent>}
      <DialogActions>
        <Button onClick={props.onCancel}>いいえ</Button>
        <Button
          variant="contained"
          disabled={props.disabledSubmit || props.loading}
          onClick={props.onSubmit}
        >
          はい
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ApprovalsModal
